import { delay, retryWhen, mergeMap } from "rxjs/operators";
import { Observable} from "rxjs";
import { of } from "rxjs/observable/of";
import { ServicesConstants } from "../services-constants";


export function delayedRetry(delayMs: number = ServicesConstants.DEFAULT_DELAY_MS, maxRetry = ServicesConstants.DEFAULT_MAX_RETRIES)
{
    let retries = maxRetry;
    return (src: Observable<any>) =>
    src.pipe(
        retryWhen((errors: Observable<any>) => errors.pipe(
            delay(delayMs),
            mergeMap(error => retries-- > 0 ? of(error) : Observable.throw(errors))
        ))
    ); 
}


// WEBPACK FOOTER //
// ./src/app/_services/delayed-retry.ts